import Layout from '@components/Items/Filters/Layout'
import useFilter from '@components/Items/utils/hooks/useFilter'
import { sort } from 'fast-sort'
import Category1 from '@components/Items/Filters/Categories/Category1'

const Categories = () => {
  const { itemCategoriesList } = useFilter()

  return (
    <Layout label={'CATEGORIES'}>
      <fieldset>
        <legend className="sr-only">Categories</legend>
        <div className="space-y-1">
          {sort(Object.entries(itemCategoriesList).filter(byValidCategoryOnes))
            .by([
              {
                asc: ([category1]) => (category1.includes('Other') ? 1 : -1),
              },
              {
                asc: ([category1]) => category1,
              },
            ])
            .map(([category1, category2List]) => (
              <Category1
                category1={category1}
                category2List={category2List}
                key={`category1-${category1}`}
              />
            ))}
        </div>
      </fieldset>
    </Layout>
  )
}

const valid = new Set([
  'Sports & Outdoors',
  'Grocery & Gourmet Food',
  'Pet Supplies',
  'Toys & Games',
  'Home & Kitchen',
  'Clothing, Shoes & Jewelry',
  'Cell Phones & Accessories',
  'Musical Instruments',
  'Automotive',
  'Health & Household',
  'Tools & Home Improvement',
  'Beauty & Personal Care',
  'Appliances',
  'Arts, Crafts & Sewing',
  'Industrial & Scientific',
  'Electronics',
  'Patio, Lawn & Garden',
  'Baby Products',
  'Office Products',
  'Books',
  'Other',
])

const byValidCategoryOnes = (cat1: [string, string[]]) => {
  return valid.has(cat1[0].split('@@')[0])
}

export default Categories
